import { RequestState }                 from '@core/interfaces/api.interface';
import { IStructureImportEntityEvents } from '@core/interfaces/entity.interface';

// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class ImportTMO {
	public createdBy: string = undefined;
	public createdDate: Date = undefined;
	public csvFileEncoding: CsvFileEncodingEnum = undefined;
	public failures: IImportFailure[] = undefined;
	public filename: string = undefined;
	public fileType: ImportFileTypeEnum = undefined;
	public id: string = undefined;
	public importFinishDate?: Date = undefined;
	public importMode: ImportModeEnum = undefined;
	public importStartDate?: Date = undefined;
	public importType: ImportTypeEnum = undefined;
	public statistics: IImportStatistics = undefined;
	public status: ImportSetStatusEnum = undefined;
	public sourceApplication?: string = undefined;
	public tenantId: string = undefined;
}


// MODEL USED IN APPLICATION (with additional properties)
export class ImportSet extends ImportTMO {
	public etag?: string = undefined;

	public ui?: IStructureImportEntityEvents = {
		requestError: undefined,
		requestState: RequestState.NOT_ASKED
	};
}

export class ImportDownload extends ImportTMO {}


// INTERFACES ########################################################
// API interfaces ****************************************************
// STATISTICS
export interface IImportStatistics {
	added: number;
	failed: number;
	processed: number;
	removed: number;
	skipped: number;
	tssAssignments: number;
	tssRequested: number;
	updated: number;
}

// OPTIONS
export interface IImportOptions {
	csvFileEncoding?: CsvFileEncodingEnum;
	fileType: string;
	importMode: ImportModeEnum;
	sourceApplication?: string;
}

// FAILURE
export interface IImportFailure {
	cause: string;
	code: string;
	identifier: string;
	message: string;
	type: ImportTypeEnum;
}

// UI interfaces *****************************************************
export interface IImportData {
	allowedFilesizeExceeded: boolean;
	file: File;
	fileExtension: string;
	importOptions: IImportOptions;
	importType: ImportTypeEnum;
	markedAsImported: boolean;
	prettyFilesize: string;
	uploadError?: { short: string, long: string };
	uploadForbidden: boolean;
	uploadProgress: number;
	uploadStatus: string;
}


// ENUMS #############################################################
// API enums *********************************************************
// Type
export enum ImportTypeEnum {
	BUSINESS_PREMISES = 'businessPremises',
	DFKA = 'dfka',
	ERS = 'ers',
	ERS_EXTERNAL = 'ersExternal',
	ORGANIZATION = 'organization',
	STRUCTURE = 'structure',
	TSS_EXTERNAL = 'tssExternal'
}

// STATUS
export enum ImportSetStatusEnum {
	FAILED = 'failed',
	IMPORTING = 'importing',
	PARTLY = 'partly',
	SUBMITTED = 'submitted',
	SUCCESS = 'success'
}

// FILE TYPE
export enum ImportFileTypeEnum {
	CSV = 'csv',
	JSON = 'json'
}

// MODE
export enum ImportModeEnum {
	ADD = 'add',
	MODIFY = 'modify',
	UPDATE = 'update'
}

// MODE
export enum CsvFileEncodingEnum {
	UTF_8 = 'UTF-8',
	UTF_16 = 'UTF-16',
	ISO_8859_1 = 'ISO-8859-1',
	ISO_8859_2 = 'ISO-8859-2',
	WINDOWS_1250 = 'windows-1250',
	WINDOWS_1252 = 'windows-1252'
}

// UI enums *********************************************************
// UPLOAD STATUS
export enum UploadStatusEnum {
	FAILED = 'failed',
	NOT_ASKED = 'not asked',
	SUCCESS = 'success',
	UPLOADING = 'uploading'
}
